import React from 'react';
import {FormInputComponent} from "../../../components/form/Form";
import {Radio} from "antd";
import User from "../../../models/User";

const TaxClassSettingsForm = (props) => {

    const taxSettings = User.ClassificationQuestionsFor1099;

    const classOptions = [
        { label: 'W-2', value: 'w2' },
        { label: '1099', value: '1099' },
        // { label: 'Orange', value: 'Orange' },
    ];

    return (
        <React.Fragment>

            <div className="field-section">


                {TB.map(taxSettings, (question, key) => {
                    return (
                        <div className="field" key={`tax_class_settings.${key}`}>
                            <FormInputComponent
                                disabled={props.isDisabled}
                                fieldName={`tax_class_settings.${key}`}
                                invalidStyles={{bottom: -30}}
                                value={props.user.tax_class_settings[key]}
                                validationErrors={{
                                    isDefaultRequiredValue: 'Your response is required'
                                }}
                                type="antd-input"
                                labelClassName="whitespace-normal"
                                required={!props.isDisabled}
                                label={question}
                                columns={10}>
                                    <Radio.Group defaultValue={props.user.tax_class_settings[key]}>
                                        <Radio value={true}>Yes</Radio>
                                        <Radio value={false}>No</Radio>
                                    </Radio.Group>

                                </FormInputComponent>
                            </div>
                        )
                    })}
                </div>
        </React.Fragment>
)
};

export default TaxClassSettingsForm;